import * as Types from '../../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type NewHomesDevelopmentDetailsSummaryQueryVariables = Types.Exact<{
    id: Types.Scalars['Int'];
    deprecatedBranchId: Types.Scalars['Int'];
}>;

export type NewHomesDevelopmentDetailsSummaryQuery = {
    __typename?: 'Query';
} & {
    newHomesDevelopmentData?: Types.Maybe<
        { __typename?: 'NewHomesDevelopmentData' } & Pick<
            Types.NewHomesDevelopmentData,
            | 'name'
            | 'logoUri'
            | 'images'
            | 'bedrooms'
            | 'helpToBuy'
            | 'sharedOwnership'
            | 'minimumPlotPrice'
            | 'listingsCount'
        > & {
                listingsDetails?: Types.Maybe<
                    { __typename?: 'ListingsDetails' } & Pick<
                        Types.ListingsDetails,
                        'hasOnlyPriceOnAsk'
                    > & {
                            listings?: Types.Maybe<
                                Array<
                                    Types.Maybe<
                                        {
                                            __typename?: 'NewHomesListing';
                                        } & Pick<
                                            Types.NewHomesListing,
                                            | 'balcony'
                                            | 'terrace'
                                            | 'garden'
                                            | 'parking'
                                            | 'garage'
                                        > & {
                                                floorArea?: Types.Maybe<
                                                    {
                                                        __typename?: 'FloorArea';
                                                    } & Pick<
                                                        Types.FloorArea,
                                                        'label' | 'value'
                                                    >
                                                >;
                                            }
                                    >
                                >
                            >;
                        }
                >;
                developer?: Types.Maybe<
                    { __typename?: 'Developer' } & Pick<Types.Developer, 'name'>
                >;
            }
    >;
};

export const NewHomesDevelopmentDetailsSummaryDocument = gql`
    query newHomesDevelopmentDetailsSummary(
        $id: Int!
        $deprecatedBranchId: Int!
    ) {
        newHomesDevelopmentData(
            id: $id
            deprecatedBranchId: $deprecatedBranchId
        ) {
            name
            logoUri
            images
            bedrooms
            helpToBuy
            sharedOwnership
            minimumPlotPrice
            listingsCount
            listingsDetails {
                hasOnlyPriceOnAsk
                listings {
                    balcony
                    terrace
                    garden
                    parking
                    garage
                    floorArea {
                        label
                        value
                    }
                }
            }
            developer {
                name
            }
        }
    }
`;

/**
 * __useNewHomesDevelopmentDetailsSummaryQuery__
 *
 * To run a query within a React component, call `useNewHomesDevelopmentDetailsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewHomesDevelopmentDetailsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewHomesDevelopmentDetailsSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      deprecatedBranchId: // value for 'deprecatedBranchId'
 *   },
 * });
 */
export function useNewHomesDevelopmentDetailsSummaryQuery(
    baseOptions: Apollo.QueryHookOptions<
        NewHomesDevelopmentDetailsSummaryQuery,
        NewHomesDevelopmentDetailsSummaryQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        NewHomesDevelopmentDetailsSummaryQuery,
        NewHomesDevelopmentDetailsSummaryQueryVariables
    >(NewHomesDevelopmentDetailsSummaryDocument, options);
}
export function useNewHomesDevelopmentDetailsSummaryLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        NewHomesDevelopmentDetailsSummaryQuery,
        NewHomesDevelopmentDetailsSummaryQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        NewHomesDevelopmentDetailsSummaryQuery,
        NewHomesDevelopmentDetailsSummaryQueryVariables
    >(NewHomesDevelopmentDetailsSummaryDocument, options);
}
export type NewHomesDevelopmentDetailsSummaryQueryHookResult = ReturnType<
    typeof useNewHomesDevelopmentDetailsSummaryQuery
>;
export type NewHomesDevelopmentDetailsSummaryLazyQueryHookResult = ReturnType<
    typeof useNewHomesDevelopmentDetailsSummaryLazyQuery
>;
export type NewHomesDevelopmentDetailsSummaryQueryResult = Apollo.QueryResult<
    NewHomesDevelopmentDetailsSummaryQuery,
    NewHomesDevelopmentDetailsSummaryQueryVariables
>;
